var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"urgency-ticker"},[_c('i',{staticClass:"urgency-ticker__icon"}),_c('p',{staticClass:"urgency-ticker__text",domProps:{"innerHTML":_vm._s(_vm.formattedText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }